import {decorate, injectable} from '@yosmanyga/di'

class MockDispatcher {
    services = new Map();
    register = jest.fn();
    retrieve = jest.fn().mockReturnValue([]);
}

decorate(injectable(), MockDispatcher)

export {
    MockDispatcher
}
